<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- Page header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <div class="flex flex-wrap items-center gap-3">
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">รถค้างในลานจอด</h1>
        <span
          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 text-xs font-bold border border-emerald-200/70 dark:border-emerald-800/50">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          ยังไม่ออกจากลาน
        </span>
      </div>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        รถที่ยังไม่มีเวลาออก และเข้าก่อนวันนี้ (ไม่นับรถที่เข้าวันปัจจุบัน) — ใช้เคลียร์รถที่ออกไปแล้วจริงแต่ระบบไม่ได้บันทึก เช่น ไม้กั้นไม่เปิด กล้องไม่อ่านทะเบียนขาออก
      </p>
    </div>

    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <div *ngIf="lastFetchedTime()"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime() | date:'HH:mm:ss' }}</span>
      </div>
      <label
        class="flex items-center gap-2 px-3 h-[46px] bg-white/95 dark:bg-slate-800/95 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 cursor-pointer select-none">
        <input type="checkbox" [(ngModel)]="enableLiveRefresh" (change)="onLiveRefreshToggle()"
          class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer">
        <span class="text-xs font-bold text-slate-600 dark:text-slate-300 whitespace-nowrap">Live (1 นาที)</span>
      </label>
      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="h-[46px] px-4 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer font-bold">
        <span class="material-icons text-[20px]">refresh</span>
        รีเฟรช
      </button>
    </div>
  </div>

  <!-- Card -->
  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">

    <!-- Card header -->
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">directions_car</span>รถที่อยู่ในลาน
          <span class="text-xs font-semibold text-slate-400 normal-case tracking-normal">({{ totalItems() | number }})</span>
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
          <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
        <div *ngIf="canEdit && selectedTransactions.size > 0" class="flex items-center gap-2 animate-fade-in">
          <span
            class="inline-flex items-center gap-1.5 text-[11px] font-bold text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/20 px-3 py-1.5 rounded-full border border-amber-200 dark:border-amber-700/50 whitespace-nowrap">
            <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
            เลือก {{ selectedTransactions.size }} คัน
          </span>
          <button type="button" (click)="openBulkCloseModal()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-rose-500 hover:bg-rose-600 text-white text-[11px] font-bold rounded-full shadow-sm shadow-rose-500/30 transition-all active:scale-95 cursor-pointer border-none whitespace-nowrap">
            <span class="material-icons text-[14px]">logout</span>
            รถออกพร้อมกัน
          </button>
        </div>
        <div class="relative flex h-[46px] w-full sm:min-w-[380px]">
          <button type="button" (click)="toggleDropdown('searchType'); $event.stopPropagation()"
            class="shrink-0 px-3 flex items-center gap-1 bg-slate-50 dark:bg-slate-900 border border-r-0 border-slate-100 dark:border-slate-700 rounded-l-xl text-xs font-bold text-slate-600 dark:text-slate-300 cursor-pointer hover:text-amber-600 transition-colors">
            {{ currentSearchTypeLabel }}
            <span class="material-icons text-sm">expand_more</span>
          </button>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" maxlength="100"
            placeholder="ค้นหา..."
            class="min-w-0 flex-1 px-4 bg-slate-50 dark:bg-slate-900 border-y border-slate-100 dark:border-slate-700 text-sm font-medium outline-none focus:ring-2 focus:ring-inset focus:ring-amber-200">
          <button type="button" (click)="onSearch()"
            class="w-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 rounded-r-xl flex items-center justify-center cursor-pointer border-none transition-colors">
            <span class="material-icons">search</span>
          </button>

          <div *ngIf="openDropdown === 'searchType'"
            class="absolute top-full left-0 mt-2 z-50 w-48 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 overflow-hidden">
            <button type="button" (click)="selectSearchType('license_plate')" class="dropdown-item">
              <span class="material-icons text-base text-slate-400">directions_car</span>ทะเบียนรถ
            </button>
            <button type="button" (click)="selectSearchType('card_name')" class="dropdown-item">
              <span class="material-icons text-base text-slate-400">badge</span>บัตร/สมาชิก
            </button>
            <button type="button" (click)="selectSearchType('gate_name')" class="dropdown-item">
              <span class="material-icons text-base text-slate-400">door_sliding</span>จุดเข้า
            </button>
          </div>
        </div>

        <button type="button" (click)="showFilters = !showFilters"
          class="relative h-[46px] px-4 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl hover:text-amber-500 hover:border-amber-300 flex items-center justify-center gap-2 font-bold cursor-pointer transition-all">
          <span class="material-icons text-[20px]">filter_list</span>ตัวกรอง
          <span *ngIf="activeFilterCount"
            class="min-w-5 h-5 px-1.5 bg-amber-400 text-slate-900 text-[10px] font-black rounded-full flex items-center justify-center">
            {{ activeFilterCount }}
          </span>
        </button>
      </div>
    </div>

    <!-- Filters panel -->
    <div *ngIf="showFilters"
      class="px-6 py-5 border-b border-slate-100 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/30 grid grid-cols-1 lg:grid-cols-2 gap-6 animate-fade-in">
      <div>
        <div class="flex items-center justify-between mb-3">
          <label class="text-xs font-bold text-slate-500 uppercase tracking-wider">จุดเข้า</label>
          <button *ngIf="gateSearchText || (selectedGates | json) !== '{}'" type="button"
            (click)="selectedGates = {}; gateSearchText = ''; onSearch()"
            class="text-xs font-bold text-amber-600 hover:text-amber-500 cursor-pointer bg-transparent border-none">ล้าง</button>
        </div>
        <input type="text" [(ngModel)]="gateSearchText" maxlength="100" placeholder="ค้นหาจุดเข้า..."
          class="w-full h-[42px] px-4 mb-3 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200">
        <div class="max-h-40 overflow-y-auto custom-scrollbar grid grid-cols-1 sm:grid-cols-2 gap-2">
          <label *ngFor="let gate of filteredGateOptions"
            class="flex items-center gap-2 p-2.5 bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 cursor-pointer hover:border-amber-200 transition-colors">
            <input type="checkbox" [checked]="selectedGates[gate]" (change)="toggleGate(gate)"
              class="w-4 h-4 rounded text-amber-500 focus:ring-amber-400 cursor-pointer">
            <span class="text-xs font-semibold truncate">{{ gate }}</span>
          </label>
          <p *ngIf="filteredGateOptions.length === 0" class="text-xs text-slate-400 p-2 col-span-full">ไม่พบจุดเข้า</p>
        </div>
      </div>

      <div>
        <div class="flex items-center justify-between mb-3">
          <label class="text-xs font-bold text-slate-500 uppercase tracking-wider">ประเภทรถ</label>
          <button *ngIf="(selectedVehicleTypes | json) !== '{}'" type="button"
            (click)="selectedVehicleTypes = {}; onSearch()"
            class="text-xs font-bold text-amber-600 hover:text-amber-500 cursor-pointer bg-transparent border-none">ล้าง</button>
        </div>
        <div class="max-h-[198px] overflow-y-auto custom-scrollbar grid grid-cols-1 sm:grid-cols-2 gap-2">
          <label *ngFor="let type of vehicleTypeOptions"
            class="flex items-center gap-2 p-2.5 bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 cursor-pointer hover:border-amber-200 transition-colors">
            <input type="checkbox" [checked]="selectedVehicleTypes[type]" (change)="toggleVehicleType(type)"
              class="w-4 h-4 rounded text-amber-500 focus:ring-amber-400 cursor-pointer">
            <span class="material-icons text-base text-slate-400">{{ getVehicleIcon(type) }}</span>
            <span class="text-xs font-semibold truncate">{{ type }}</span>
          </label>
        </div>
      </div>

      <div class="lg:col-span-2 flex justify-end">
        <button type="button" (click)="clearFilters()"
          class="px-4 py-2 border border-slate-200 dark:border-slate-700 rounded-xl text-xs font-bold text-slate-500 hover:text-rose-500 hover:border-rose-200 cursor-pointer flex items-center gap-1 bg-white dark:bg-slate-800 transition-all">
          <span class="material-icons text-base">filter_list_off</span>ล้างตัวกรองทั้งหมด
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar"
      [class.opacity-50]="isLoading()" [class.pointer-events-none]="isLoading()">
      <table class="w-full min-w-[980px] text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th *ngIf="canEdit" class="p-4 w-[48px] text-center">
              <input type="checkbox" [checked]="isAllSelected" (change)="toggleSelectAll()"
                [disabled]="transactions().length === 0" title="เลือกทั้งหมดในหน้านี้"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer">
            </th>
            <th (click)="sortData('entryLicense')" class="p-4 cursor-pointer hover:text-amber-500 transition-colors select-none">
              ทะเบียนรถ
              <span *ngIf="sortColumn === 'entryLicense'" class="material-icons sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span>
            </th>
            <th (click)="sortData('cardName')" class="p-4 cursor-pointer hover:text-amber-500 transition-colors select-none">
              บัตร
              <span *ngIf="sortColumn === 'cardName'" class="material-icons sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span>
            </th>
            <th class="p-4 text-center">ประเภท</th>
            <th (click)="sortData('entryDate')" class="p-4 cursor-pointer hover:text-amber-500 transition-colors select-none">
              เวลาเข้า
              <span *ngIf="sortColumn === 'entryDate'" class="material-icons sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span>
            </th>
            <th class="p-4">จุดเข้า</th>
            <th class="p-4">ระยะเวลาจอด</th>
            <th class="p-4 text-center w-[100px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of transactions(); let index = index"
            class="animate-table-row hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all"
            [class.bg-amber-50]="selectedTransactions.has(item.id)"
            [style.animation-delay.ms]="index * 30">
            <td *ngIf="canEdit" class="p-4 text-center">
              <input type="checkbox" [checked]="selectedTransactions.has(item.id)" (change)="toggleSelection(item.id)"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 cursor-pointer">
            </td>
            <td class="p-4">
              <div class="flex items-center gap-3">
                <button type="button" (click)="openImageModal(entryImageUrl(item))"
                  class="w-20 h-14 shrink-0 rounded-xl overflow-hidden bg-slate-100 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 cursor-zoom-in hover:border-amber-300 transition-colors">
                  <img [src]="entryImageUrl(item)" [alt]="item.entryLicense || 'ภาพรถ'"
                    class="w-full h-full object-cover"
                    (error)="$any($event.target).src='img/notfound.jpg'">
                </button>
                <div class="min-w-0">
                  <div class="flex items-center gap-1.5">
                    <span class="font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ item.entryLicense || '—' }}</span>
                    <button type="button" (click)="openEditLicenseModal(item)" title="แก้ไขทะเบียน"
                      class="w-7 h-7 rounded-lg border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 flex items-center justify-center cursor-pointer bg-transparent transition-all">
                      <span class="material-icons text-[15px]">edit</span>
                    </button>
                  </div>
                  <span class="text-[11px] text-slate-400">{{ item.entryProvince || '—' }}</span>
                </div>
              </div>
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ item.cardName || '—' }}</div>
              <div class="text-[11px] font-mono text-slate-400 mt-0.5">{{ item.cardCode || '—' }}</div>
            </td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-[11px] font-bold"
                [ngClass]="item.member
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-300'">
                {{ item.member ? 'Member' : 'Visitor' }}
              </span>
              <div class="text-[11px] text-slate-400 mt-1">{{ item.vehicleTypeName || 'ทั่วไป' }}</div>
            </td>
            <td class="p-4 whitespace-nowrap">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ formatDateDisplay(item.entryDate) }}</div>
              <div class="text-[11px] text-slate-400 mt-0.5">{{ item.siteName || '—' }}</div>
            </td>
            <td class="p-4">
              <span class="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 dark:text-slate-300">
                <span class="w-2 h-2 rounded-full bg-emerald-500 shrink-0"></span>
                {{ item.entryGateName || 'ไม่ระบุ' }}
              </span>
            </td>
            <td class="p-4">
              <span
                class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 text-xs font-bold">
                <span class="material-icons text-[14px]">schedule</span>{{ parkingDuration(item.entryDate) }}
              </span>
            </td>
            <td class="p-4 text-center">
              <div class="inline-flex items-center gap-2">
                <button type="button" (click)="openDetailModal(item)" title="ดูรายละเอียด"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer bg-transparent">
                  <span class="material-icons text-base">visibility</span>
                </button>
                <button *ngIf="canEdit" type="button" (click)="openForceExitModal(item)" title="ทำรายการออก"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center bg-rose-50 dark:bg-rose-900/10 border border-rose-200 dark:border-rose-800/50 text-rose-500 hover:bg-rose-500 hover:text-white hover:border-rose-500 transition-all cursor-pointer active:scale-95">
                  <span class="material-icons text-base">logout</span>
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="!siteState.selectedSite()?.id && !isLoading()">
            <td [attr.colspan]="canEdit ? 8 : 7" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 opacity-40 block">location_off</span>
              <p class="font-bold">กรุณาเลือกลานจากแถบด้านบน</p>
            </td>
          </tr>
          <tr *ngIf="siteState.selectedSite()?.id && !isLoading() && transactions().length === 0">
            <td [attr.colspan]="canEdit ? 8 : 7" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 opacity-40 block">done_all</span>
              <p class="font-bold">ไม่มีรถค้างในลาน</p>
              <p class="text-xs mt-1">ไม่พบรายการที่เข้าก่อนวันนี้และยังไม่ออกจากลาน</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <div class="relative">
          <button type="button" (click)="toggleDropdown('pageSize'); $event.stopPropagation()"
            class="h-9 px-3 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 font-bold text-sm flex items-center gap-1 cursor-pointer hover:border-amber-300 transition-colors">
            {{ pageSize }} / หน้า <span class="material-icons text-sm">expand_more</span>
          </button>
          <div *ngIf="openDropdown === 'pageSize'"
            class="absolute bottom-full left-0 mb-2 z-50 min-w-full bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 overflow-hidden">
            <button *ngFor="let size of pageSizeOptions" type="button" (click)="selectPageSize(size)"
              class="w-full px-3 py-2 text-left text-xs font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 cursor-pointer border-none bg-transparent text-slate-600 dark:text-slate-300">
              {{ size }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <button type="button" (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" type="button" (click)="onPageChange(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
          [ngClass]="page === currentPage
            ? 'bg-amber-400 text-white shadow-sm'
            : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 bg-transparent'">
          {{ page }}
        </button>
        <button type="button" (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages()"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showImageModal"
  class="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/70 backdrop-blur-md p-4"
  (click)="closeImageModal()">
  <button type="button"
    class="absolute top-4 right-4 w-10 h-10 rounded-xl text-white hover:bg-white/10 hover:text-amber-400 cursor-pointer border-none bg-transparent flex items-center justify-center transition-all"
    (click)="closeImageModal()">
    <span class="material-icons text-3xl">close</span>
  </button>
  <img [src]="selectedImageUrl" alt="ภาพรถขณะเข้า"
    class="max-w-full max-h-[90vh] rounded-[1.5rem] shadow-2xl border border-white/10"
    (click)="$event.stopPropagation()"
    (error)="$any($event.target).src='img/notfound.jpg'">
</div>

<app-modal-transaction-parking-detail
  *ngIf="showDetailModal"
  [parkingTransaction]="selectedParkingTransaction"
  [userId]="userId"
  (close)="closeDetailModal()"
  (openImage)="openImageModal($event)">
</app-modal-transaction-parking-detail>

<app-modal-transaction-parking-edit-license
  [isOpen]="showEditLicenseModal"
  [data]="editLicenseData"
  (onClose)="closeEditLicenseModal()"
  (onSuccess)="closeEditLicenseModal(); loadTransactions()">
</app-modal-transaction-parking-edit-license>

<app-modal-force-exit-transaction [isOpen]="showForceExitModal" [siteId]="selectedSiteId" [userId]="userId"
  [transaction]="selectedForceExitTransaction" (onClose)="closeForceExitModal()"
  (onSuccess)="onForceExitSuccess()">
</app-modal-force-exit-transaction>

<!-- Bulk Close Modal -->
<div *ngIf="showBulkCloseModal" class="fixed inset-0 z-[60] flex items-center justify-center">
  <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="closeBulkCloseModal()"></div>
  <div
    class="w-full max-w-md bg-white dark:bg-slate-800 rounded-3xl shadow-2xl relative z-10 border border-slate-100 dark:border-slate-700 m-4 flex flex-col">
    <div
      class="p-6 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/50 rounded-t-3xl">
      <h2 class="text-xl font-bold flex items-center gap-3 text-slate-800 dark:text-white">
        <div class="w-10 h-10 rounded-xl bg-orange-100 text-orange-500 flex items-center justify-center shrink-0">
          <span class="material-icons text-[22px]">exit_to_app</span>
        </div>
        ทำรายการออกพร้อมกัน
      </h2>
      <button type="button" (click)="closeBulkCloseModal()"
        class="w-8 h-8 flex items-center justify-center rounded-xl bg-slate-100 dark:bg-slate-700 text-slate-500 hover:text-slate-800 dark:hover:text-white transition-colors cursor-pointer border-none">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <div class="p-6">
      <div
        class="mb-4 bg-orange-50 dark:bg-orange-900/20 p-3 rounded-xl border border-orange-100 dark:border-orange-800/30 flex items-start gap-3">
        <span class="material-icons text-orange-500 mt-0.5">info</span>
        <p class="text-sm text-slate-600 dark:text-slate-300 font-medium leading-relaxed">
          คุณกำลังจะทำรายการรถออกจำนวน
          <span class="font-black text-orange-600 dark:text-orange-400 text-base mx-1">{{ selectedTransactions.size }}</span> คัน
        </p>
      </div>

      <label class="mb-4 flex items-start gap-3 cursor-pointer p-3 rounded-xl border transition-colors"
        [ngClass]="bulkLocalOnly
          ? 'bg-rose-50 dark:bg-rose-900/20 border-rose-200 dark:border-rose-800/40'
          : 'bg-slate-50 dark:bg-slate-900/40 border-slate-100 dark:border-slate-700'">
        <input type="checkbox" [(ngModel)]="bulkLocalOnly"
          class="mt-0.5 w-4 h-4 rounded border-slate-300 text-rose-500 focus:ring-rose-400 shrink-0">
        <span>
          <span class="block text-sm font-bold text-slate-700 dark:text-slate-200">ปิดเฉพาะใน DB (ไม่ส่ง Taiwan)</span>
          <span class="block text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 leading-relaxed">
            ใช้กรณี Taiwan ปิดรายการไปแล้วแต่ไม่ได้แจ้งกลับมา — ระบบจะใส่เวลาออกทันทีโดยไม่ส่งคำสั่งไป Taiwan
          </span>
        </span>
      </label>

      <div *ngIf="!bulkLocalOnly && bulkExitGates.length > 0" class="mb-4 relative">
        <label class="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">ประตูออก <span
            class="text-rose-500">*</span></label>
        <div class="relative flex items-center">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">door_sliding</span>
          <input type="text" [(ngModel)]="bulkGateSearchText" placeholder="เลือกประตูออก"
            (focus)="isBulkGateDropdownOpen = true" (input)="isBulkGateDropdownOpen = true"
            (blur)="closeBulkGateDropdown()"
            class="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 text-sm rounded-xl block pl-10 pr-10 p-3 transition-all placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-200">
          <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
        </div>
        <div *ngIf="isBulkGateDropdownOpen" (mousedown)="$event.preventDefault()"
          class="absolute top-full mt-1 left-0 right-0 z-20 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 max-h-56 overflow-y-auto custom-scrollbar">
          <button *ngFor="let g of filteredBulkExitGates" type="button" (click)="selectBulkExitGate(g)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium transition-colors flex items-center justify-between border-none cursor-pointer"
            [ngClass]="g.id === bulkExitGateId
              ? 'bg-orange-50 dark:bg-orange-900/20 text-orange-600'
              : 'bg-transparent text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-orange-600'">
            {{ g.name }}
            <span *ngIf="g.id === bulkExitGateId" class="material-icons text-[18px]">check</span>
          </button>
          <div *ngIf="filteredBulkExitGates.length === 0" class="px-4 py-3 text-sm text-slate-400">ไม่พบประตูออก</div>
        </div>
        <p class="text-[11px] text-slate-400 mt-1.5">
          ลาน Taiwan จะส่งรายการออกไป Taiwan (ไม่เปิดไม้กั้น) แล้วรอ Taiwan ยืนยันการออกกลับมา
        </p>
      </div>

      <div class="mb-2">
        <label class="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">เหตุผล / หมายเหตุ <span
            class="text-rose-500">*</span></label>
        <input type="text" [(ngModel)]="bulkRemark" maxlength="200"
          placeholder="เช่น ไม้กั้นไม่เปิด, กล้องไม่อ่านทะเบียนขาออก"
          class="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 text-sm rounded-xl block p-3 transition-all placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-200">
      </div>
    </div>

    <div
      class="p-6 bg-slate-50 dark:bg-slate-800/50 flex justify-end gap-3 rounded-b-3xl border-t border-slate-100 dark:border-slate-700">
      <button type="button" (click)="closeBulkCloseModal()" [disabled]="isBulkClosing"
        class="px-5 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-xl transition-colors min-w-[100px] cursor-pointer border-none bg-transparent">
        ยกเลิก
      </button>
      <button type="button" (click)="confirmBulkClose()" [disabled]="isBulkClosing"
        class="px-5 py-2.5 text-sm font-bold text-white bg-orange-500 hover:bg-orange-600 rounded-xl shadow-md shadow-orange-500/20 transition-all active:scale-95 disabled:opacity-50 min-w-[120px] flex justify-center items-center gap-2 cursor-pointer border-none">
        <span *ngIf="isBulkClosing" class="material-icons animate-spin text-[18px]">autorenew</span>
        <span>{{ isBulkClosing ? 'กำลังบันทึก...' : 'บันทึกพร้อมกัน' }}</span>
      </button>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
